(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.dades', [
      'ui.router'
    ]);
}());
